const kGlobalConstants = {
  API_HOST: 'https://stream-tools.app',
  API_PORT: '5000',
  NAMESPACE: 'live',
  CUTOFF: 0
};

export default kGlobalConstants;
